import Model from 'models/Model';

export default class ArticleCategory implements Model {
    id: string;
    name: string;
    slug: string;

    constructor(data: ArticleCategory) {
        this.id = data.id;
        this.name = data.name;
        this.slug = data.slug;
    }
}
